import { compose } from 'recompose';

import { withNamespaces } from 'react-i18next';
import AttachFilesModal from './attachFilesModal';

const enhance = compose(
  withNamespaces(['chat', 'common']),
);
export default enhance(AttachFilesModal);
